import {notifyDownload} from "utils/android";

export function downloadPdfFromBase64(pdf: string, fileName: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = `${fileName}.pdf`;
    downloadLink.click();
}

export function downloadPDF(url: string, filename: string, isAndroid: boolean) {
    fetch(url).then((response) => {
        return response.blob().then((blob) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.addEventListener("load", () => {
                if (typeof reader.result === "string") {
                    const base64Data = reader.result.replace(/^data:.+;base64,/, "");
                    if (isAndroid) {
                        notifyDownload(filename, base64Data, null, "application/pdf");
                    } else {
                        downloadPdfFromBase64(base64Data, filename);
                    }
                }
            });
        });
    });
}
